import { Injectable } from "@angular/core";
import {
  MessageBus,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "../../provider-webworker";

export class LocalServiceMessageBroker extends ServiceMessageBroker {
  private methodMapping: any = {};

  constructor(public channel: string) {
    super();
  }

  registerMethod(
    methodName: string,
    signature: any[],
    method: any,
    returnType?: any,
    returnTransferable?: boolean,
    returnTransferableIsArray?: boolean,
  ): void {
    this.methodMapping[methodName] = method;
  }

  addSource(messageBus: MessageBus) {
    console.debug("Got a message bus: ", messageBus);
  }
}

@Injectable()
export class LocalServiceMessageBrokerFactory extends ServiceMessageBrokerFactory {
  constructor() {
    super(null, null, false, false, null, null);
  }

  createMessageBroker(
    channel: string,
    runInZone?: boolean,
    hasTransfers?: boolean,
  ): import("../../provider-webworker").ServiceMessageBroker {
    return new LocalServiceMessageBroker(channel);
  }
}
